import React, { Component } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';

export const columns = [
  {
    Header: 'Student Number',
    accessor: 'StudentNumber',
    sortable: true,
    minWidth: 125,
  },
  {
    Header: 'State Number',
    accessor: 'StateNumber',
    sortable: true,
    minWidth: 110,
  },
  {
    Header: 'Last Name',
    accessor: 'LastName',
    sortable: true,
    minWidth: 125,
  },
  {
    Header: 'First Name',
    accessor: 'FirstName',
    sortable: true,
    minWidth: 125,
  },

  {
    Header: 'Birth Date',
    Cell: ({ value }) => defaultDateFormat(value),
    accessor: 'StudentBirthDate',
    sortable: true,
    minWidth: 100,
  },
  {
    Header: 'Case Number',
    accessor: 'StudentCaseNumber',
    sortable: true,
    minWidth: 100,
  },
  {
    Header: 'Case Type',
    accessor: 'STU_CaseType.Description',
    sortable: true,
    minWidth: 100,
  },
  {
    Header: 'HoH Last Name',
    accessor: 'ParentLastName',
    sortable: true,
    minWidth: 125,
  },
  {
    Header: 'HoH First Name',
    accessor: 'ParentFirstName',
    sortable: true,
    minWidth: 125,
  },

  {
    Header: 'Address 1',
    accessor: 'Address1',
    sortable: true,
    minWidth: 150,
  },
  {
    Header: 'Address 2',
    accessor: 'Address2',
    sortable: true,
    minWidth: 125,
  },
  {
    Header: 'City',
    accessor: 'City',
    sortable: true,
    minWidth: 100,
  },
  {
    Header: 'State',
    accessor: 'State',
    sortable: true,
    minWidth: 65,
  },
  {
    Header: 'Zip',
    accessor: 'ZipCode',
    sortable: true,
    minWidth: 125,
  },
];

export class UnmatchedTable extends Component {
  static propTypes = {
    unmatched: PropTypes.array.isRequired,
    onRowSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    pages: PropTypes.number,
  };

  static defaultProps = {
    loading: false,
    pages: -1,
  };

  formatSorted = (sortOptions) => {
    return sortOptions.map((so) => ({
      SortName: so.id,
      SortDirection: so.desc ? 'desc' : 'asc',
    }));
  };

  formatFiltered = (filterOptions) => {
    return filterOptions.map((fo) => ({
      FilterName: fo.id,
      FilterValue: fo.value,
      FilterType: PagingFilterTypeEnum.MatchFromStart,
    }));
  };

  fetchData = (state, instance) => {
    const { getUnmatched } = this.props;

    getUnmatched(
      state.page + 1,
      state.pageSize,
      this.formatSorted(state.sorted),
      this.formatFiltered(state.filtered)
    );
  };

  render() {
    const { onRowSelect, pages } = this.props;

    return (
      <ReactTable
        loading={this.props.loading}
        pages={pages}
        data={this.props.unmatched}
        filterable={true}
        columns={columns}
        noDataText="None Found"
        resizable={true}
        getTrProps={(state, rowInfo, column) => {
          return rowInfo && rowInfo.row
            ? {
                className: ClassNames('cursor-pointer'),
                onClick: (e) => onRowSelect(rowInfo.original),
              }
            : {};
        }}
        onFetchData={this.fetchData}
        manual={true}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/dcunmatchedutility/components/UnmatchedTable.js